
import popupComponent from "./popup-component";

const commonComponent = {
    install: (Vue) => {
        Vue.component("popupComponent", popupComponent);
    },
}
export default commonComponent;



// WEBPACK FOOTER //
// src/components/common-component.js